import angular from 'angular';

import component from './searchResultsLink.component';
import service from './searchResultsLink.service';


import Listing from '../listing/index';

import Browser from 'cars-ng-browser';
import CarsNgTracking from 'cars-ng-tracking';

export default angular.module('cars.enhanced.vdp.searchResultsLink', [
    Listing,
    Browser,
    'cars.ui.angular',
    CarsNgTracking
])

    .component('vdpeSearchResultsLink', component)
    .service('searchResultsLinkService', service)

    .name;
